/**
 * Portuguese legal copy — approved translation (você, Brazilian-neutral).
 * Source: /app/drafts/legal_translations/pt.md with Laura's refinement:
 *   - AI Notice: "você compreende" → "você entende" (more natural in BR)
 */

const pt = {
    terms: {
        preamble: [
            { type: "para", text: 'Other Side é uma plataforma digital operada por Laura Stella, atuando sob o nome "Other Side".' },
        ],
        sections: [
            { number: 1, title: "Natureza do serviço", blocks: [
                { type: "para", text: "Other Side utiliza tecnologias de inteligência artificial para gerar experiências simuladas baseadas nos conteúdos fornecidos por você." },
                { type: "para", text: "As interações geradas não representam comunicações reais nem implicam a presença ou consciência da pessoa representada." },
            ]},
            { number: 2, title: "Requisitos de uso", blocks: [
                { type: "para", text: "Você deve ter pelo menos 18 anos e utilizar o serviço respeitando as leis aplicáveis." },
            ]},
            { number: 3, title: "Responsabilidade sobre conteúdos", blocks: [
                { type: "para", text: "Você é responsável pelos conteúdos carregados e declara ter o direito de utilizá-los." },
            ]},
            { number: 4, title: "Pessoas representadas", blocks: [
                { type: "para", text: "Você garante não violar direitos de terceiros, incluindo direitos relativos a pessoas falecidas." },
            ]},
            { number: 5, title: "Uso proibido", blocks: [
                { type: "para", text: "É proibido o uso do serviço para finalidades ilegais, fraudulentas ou lesivas aos direitos de terceiros." },
            ]},
            { number: 6, title: "Limitação de responsabilidade", blocks: [
                { type: "para", text: "Other Side não é responsável por interpretações subjetivas, reações emocionais ou uso inadequado do serviço." },
            ]},
            { number: 7, title: "Interrupção", blocks: [
                { type: "para", text: "O serviço pode ser suspenso ou limitado em caso de violações." },
            ]},
            { number: 8, title: "Seus direitos", blocks: [
                { type: "para", text: "Você pode solicitar acesso, modificação ou exclusão dos seus dados." },
            ]},
            { number: 9, title: "Alterações", blocks: [
                { type: "para", text: "Os termos podem ser atualizados a qualquer momento." },
            ]},
            { number: 10, title: "Lei aplicável", blocks: [
                { type: "para", text: "O serviço é regido pela legislação europeia aplicável." },
            ]},
        ],
    },

    privacy: {
        preamble: [
            { type: "contact", label: "Controlador dos dados", value: 'Laura Stella, atuando sob o nome "Other Side"' },
            { type: "contact", label: "Email", value: "os.otherside.app@gmail.com", mailto: true },
        ],
        sections: [
            { number: 1, title: "Tipos de dados coletados", blocks: [
                { type: "list", items: [
                    "Dados identificativos",
                    "Conteúdos carregados (imagens, áudio, vídeo)",
                    "Dados biométricos (voz, imagens)",
                    "Dados técnicos (IP, dispositivo, logs)",
                ]},
            ]},
            { number: 2, title: "Finalidades", blocks: [
                { type: "list", items: [
                    "Prestação do serviço",
                    "Geração de conteúdos IA",
                    "Segurança e melhoria",
                ]},
            ]},
            { number: 3, title: "Base jurídica", blocks: [
                { type: "list", items: [
                    "Consentimento explícito",
                    "Execução do serviço",
                ]},
            ]},
            { number: 4, title: "Dados biométricos", blocks: [
                { type: "para", text: "Os dados biométricos são tratados somente mediante o seu consentimento explícito." },
            ]},
            { number: 5, title: "Conservação", blocks: [
                { type: "para", text: "Os dados são conservados pelo tempo necessário ao serviço." },
            ]},
            { number: 6, title: "Seus direitos", blocks: [
                { type: "para", text: "Acesso, retificação, exclusão, limitação, oposição." },
            ]},
            { number: 7, title: "Transferências", blocks: [
                { type: "para", text: "Os dados podem ser tratados em servidores situados na União Europeia ou fora dela, respeitando as normas aplicáveis." },
            ]},
            { number: 8, title: "Segurança", blocks: [
                { type: "para", text: "São adotadas medidas técnicas e organizativas para proteger os dados." },
            ]},
            { number: 9, title: "Reclamações", blocks: [
                { type: "para", text: "Você pode entrar em contato com a autoridade de proteção de dados competente." },
            ]},
        ],
    },

    biometric: {
        preamble: [
            { type: "para", text: "Você presta consentimento explícito ao tratamento de:" },
        ],
        sections: [
            { title: "Dados biométricos envolvidos", blocks: [
                { type: "list", items: ["imagens", "voz", "conteúdos de áudio e vídeo"] },
                { type: "para", text: "para fins de criação da experiência digital." },
            ]},
            { title: "Natureza do consentimento", blocks: [
                { type: "para", text: "O consentimento é:" },
                { type: "list", items: ["livre", "informado", "revogável"] },
            ]},
            { title: "Revogação", blocks: [
                { type: "para", text: "A revogação pode ocorrer a qualquer momento através das configurações da sua conta ou solicitação direta." },
            ]},
        ],
    },

    ai_notice: {
        preamble: [
            { type: "para", text: "Other Side utiliza sistemas de inteligência artificial." },
        ],
        sections: [
            { title: "As interações", blocks: [
                { type: "list", items: [
                    "são geradas artificialmente",
                    "podem simular voz, estilo e conteúdos",
                    "não representam comunicações reais",
                ]},
            ]},
            { title: "Limites do sistema", blocks: [
                { type: "para", text: "O serviço não recria consciência ou identidade real." },
                { type: "para", text: "Você aceita interagir com um sistema de IA e entende seus limites." },
            ]},
        ],
    },

    memorial: {
        preamble: [
            { type: "para", text: "Other Side permite a criação de experiências baseadas em conteúdos relativos a pessoas." },
        ],
        sections: [
            { number: 1, title: "Responsabilidade", blocks: [
                { type: "para", text: "Você é responsável pelos conteúdos carregados." },
            ]},
            { number: 2, title: "Pessoas falecidas", blocks: [
                { type: "para", text: "Você declara ter o direito ou autorização para utilizar os conteúdos." },
            ]},
            { number: 3, title: "Direitos dos familiares", blocks: [
                { type: "para", text: "Solicitações de remoção ou modificação podem ser feitas por partes legitimadas." },
            ]},
            { number: 4, title: "Denúncias", blocks: [
                { type: "para", text: "Other Side se reserva o direito de remover conteúdos contestados." },
            ]},
            { number: 5, title: "Limitações", blocks: [
                { type: "para", text: "O serviço não garante precisão histórica ou representação real." },
            ]},
        ],
    },
};

export default pt;
